import { useMediaQuery, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import React, { PropsWithChildren, ReactElement } from 'react'

import MobileTabs from './MobileTabs/MobileTabs'
import RegularTabs, { TabObject } from './RegularTabs'
import styles from './Tabs.module.less'

type TabsProps = {
  handleChange: (event: React.ChangeEvent<unknown>, newValue: number) => void
  tabObjects: TabObject[]
  value: number
}

export default function Tabs({ children, ...props }: PropsWithChildren<TabsProps>): ReactElement {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Grid container direction="column">
      <Grid>{isDesktop ? <RegularTabs {...props} /> : <MobileTabs {...props} />}</Grid>
      <Grid className={styles.Tabs_Border}>{children}</Grid>
    </Grid>
  )
}
